import { colors } from '@alixpartners/ui-components';

export const MAP_COLORS = ['#DBE9ED', '#D3D8D9'];

export const PIE_INACTIVE_COLORS = [
	colors.chartDarkGrey,
	colors.chartMediumGrey,
	colors.grey3,
	colors.grey4,
];

export const MARKER_SIZE = {
	min: 10,
	max: 25,
};

export const MAX_ZOOM_LEVEL = 8;
export const ZOOM_FACTOR = 4;
